// Sprint 3.B: lista de llamadas grabadas para una deuda con player inline.
//
// Lee onSnapshot de la coleccion llamadas (poblada por la app KYE Call
// Center Desktop a traves de la Cloud Function procesarLlamada) y muestra:
//   - Fecha + duracion + cobrador + telefono marcado
//   - Boton "Reproducir" que resuelve la URL pública de Storage on-demand
//   - Player HTML5 nativo con scrubbing
//
// Sprint 4 agrega: descarga, transcripcion IA, sentimiento, resumen.

import { useEffect, useState } from "react";
import {
  escucharLlamadasPorDeuda,
  getAudioPlayableUrl,
  formatDuracion,
} from "../../services/llamadasService";
import { toJsDate } from "../../helpers/fechas";
import "./LlamadasDeuda.css";

function fmtFecha(ts) {
  const d = toJsDate(ts);
  if (!d) return "—";
  return d.toLocaleString("es-MX", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export default function LlamadasDeuda({ deudaId }) {
  const [llamadas, setLlamadas] = useState(null);
  const [reproduciendo, setReproduciendo] = useState(null); // callId que se está reproduciendo
  const [audioUrl, setAudioUrl] = useState(null);
  const [errorUrl, setErrorUrl] = useState(null);
  const [cargandoUrl, setCargandoUrl] = useState(false);

  useEffect(() => {
    if (!deudaId) return undefined;
    const unsub = escucharLlamadasPorDeuda(deudaId, setLlamadas, 50);
    return unsub;
  }, [deudaId]);

  async function handleReproducir(llamada) {
    setErrorUrl(null);
    setAudioUrl(null);
    setReproduciendo(llamada.id);
    setCargandoUrl(true);
    try {
      const url = await getAudioPlayableUrl(llamada.audioPath);
      setAudioUrl(url);
    } catch (err) {
      console.error("[LlamadasDeuda] no se pudo cargar audio:", err);
      setErrorUrl(`No se pudo cargar el audio: ${err?.message || err}`);
    } finally {
      setCargandoUrl(false);
    }
  }

  if (llamadas === null) {
    return (
      <div className="llamadas-deuda">
        <h4>Llamadas grabadas</h4>
        <p className="llamadas-deuda-empty">Cargando llamadas…</p>
      </div>
    );
  }

  if (llamadas.length === 0) {
    return (
      <div className="llamadas-deuda">
        <h4>Llamadas grabadas</h4>
        <p className="llamadas-deuda-empty">
          Sin llamadas registradas para esta deuda.
        </p>
      </div>
    );
  }

  return (
    <div className="llamadas-deuda">
      <h4>
        Llamadas grabadas <span className="llamadas-deuda-count">({llamadas.length})</span>
      </h4>
      <ul className="llamadas-deuda-list">
        {llamadas.map((l) => {
          const isActive = reproduciendo === l.id;
          return (
            <li key={l.id} className={`llamadas-deuda-item ${isActive ? "active" : ""}`}>
              <div className="llamadas-deuda-row">
                <div className="llamadas-deuda-meta">
                  <strong>{fmtFecha(l.creadoEn || l.inicio)}</strong>
                  <span className="llamadas-deuda-sub">
                    {formatDuracion(l.duracionSeg)} ·{" "}
                    {l.responsableNombre || l.responsableEmail || "—"}
                    {l.telefonoMarcado ? ` · ${l.telefonoMarcado}` : ""}
                  </span>
                </div>
                <button
                  type="button"
                  className="llamadas-deuda-btn"
                  onClick={() => handleReproducir(l)}
                  disabled={isActive && cargandoUrl}
                >
                  {isActive && cargandoUrl ? "Cargando…" : isActive ? "Reproduciendo" : "▶ Reproducir"}
                </button>
              </div>
              {isActive && audioUrl && (
                <audio
                  className="llamadas-deuda-audio"
                  controls
                  autoPlay
                  src={audioUrl}
                  onError={() => setErrorUrl("Error al reproducir el archivo.")}
                />
              )}
              {isActive && errorUrl && (
                <div className="llamadas-deuda-error">{errorUrl}</div>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
